module.exports = __webpack_public_path__ + "img/w3_trash_delete_black.862fb03c.png";